import { useEffect, useState } from 'react';
import { useForm, ValidationError } from '@formspree/react';
import "./ContactForm.css";

export default function ContactForm() {
    const [state, handleSubmit] = useForm("meerdlvq");
    const [message, setMessage] = useState("");

    const resetForm = () => {
        // Reset form fields
        document.getElementById("firstName").value = "";
        document.getElementById("lastName").value = "";
        document.getElementById("email").value = "";
        document.getElementById("phone").value = "";
        document.getElementById("message").value = "";
    };

    useEffect(() => {
        if (state.succeeded) {
            resetForm();
            setMessage("Thank you for your message! I will get back to you soon.");
        }

        if (state.errors) {
            setMessage("Oops! Something went wrong. Please try again.");
        }
    }, [state]);


    return (
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "100vh", backgroundColor: "rgb(19, 30, 37)" }}>
            <form className="contact-form" onSubmit={handleSubmit} action={"https://formspree.io/f/meerdlvq"}>
                <div style={{ textAlign: "center", fontFamily: "Permanent Marker, cursive" }}>
                    <h1>Contact Me!</h1>
                </div>
                <div className="form-row">
                    <div className="form-field">
                        <input id="firstName" name="firstName" type="text" placeholder={"Name"} required minLength={2} />
                    </div>
                    </div>
                <div className="form-row">
                    <div className="form-field">
                        <input id="lastName" name="lastName" type="text" placeholder={"Last Name"} required minLength={2} />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-field">
                        <input id="email" name="email" type="email" placeholder={"Email"} required />
                    </div>
                    </div>
                <div className="form-row" style={{ display: state.errors ? 'block' : 'none' }}>
                    <ValidationError
                        prefix="Email"
                        field="email"
                        errors={state.errors}
                    />
                </div>
                    <div className="form-field">
                        <input
                            id="phone"
                            name="phone"
                            type="tel"
                            inputMode="tel"
                            pattern="^[+()0-9\s-]{7,}$"
                            placeholder="+358 40123 4567"
                        />
                    </div>

                <div className="message-field">
                    <textarea id="message" name="message" rows={5} placeholder={"Message"} required />
                </div>

                <div className="form-row" style={{ display: state.errors ? 'block' : 'none' }}>
                    <ValidationError
                        prefix="Message"
                        field="message"
                        errors={state.errors}
                    />
                </div>
                {message ? <p className="form-message">{message}</p> : <button type="submit" style={{ cursor: "pointer", height: "40px", color: "black", border: "1px #514b4bff solid" }} disabled={state.submitting}>
                    {"submit"}
                </button>}
            </form>
        </div>

    )
}